import type { RouteLocation } from 'vue-router';
import { useGlobalStore } from '~/stores/global';
import { useInteractiveStore } from '~/stores/interactive';

export default defineNuxtPlugin(() => {
  const globalStore = useGlobalStore();
  const interactiveStore = useInteractiveStore();
  if (interactiveStore.isPageSpeedBot) return;
  const runtimeConfig = useRuntimeConfig();
  const isProd = runtimeConfig.public.isProd;
  if (!isProd || globalStore.webview) return;
  const router = useRouter();

  function init() {
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-VYH7S35C9Z';
    script.async = true;
    document.getElementsByTagName('head')[0].appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      originalLocation:
        document.location.protocol +
        '//' +
        document.location.hostname +
        document.location.pathname +
        document.location.search,
    });

    window.gtag = function () {
      // @ts-ignore
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    };
    script.addEventListener('load', () => {
      try {
        if (window?.gtag) {
          const gtag = window?.gtag;
          gtag('js', new Date());
          const gtagOptions = {
            send_page_view: false,
          };
          gtag('config', 'G-VYH7S35C9Z', gtagOptions);
          router.afterEach((to: RouteLocation, from: RouteLocation) => {
            gtag('set', 'page_path', to.fullPath);
            gtag('event', 'page_view');
            if (to.path !== from.path || !from.name) {
              const pageType = globalStore.seoData?.page?.type || to.path;
              if (
                ![
                  'brand',
                  'category-list',
                  'category-preset',
                  'category-brand',
                  'category-discount',
                  'shop-offers',
                  '/search/',
                  '/search',
                  'index',
                  'model',
                ].includes(pageType)
              )
                window.dataLayer.push({
                  ecomm_pagetype: 'other',
                });
            }
          });
        }
      } catch (e) {
        console.error('gtag plugin', e);
      }
    });
  }

  interactiveStore.addFunction(init);
});
